import { getData } from "./axiosConfig"

export const checkSubscription = async () => {
    return await getData("user/subscription-valid")
}

export const booksChapter = async (id) => {
    return await getData(`book/chapters/${id}`)
}

export const cancelSubscription = async (id) => {
    return await getData(`user/cancel-subscription/${id}`)
}


